import { createContext, useContext } from 'react';

type DynamicContentBuilderContextState = {
  toggle: () => void;
};

export const DYNAMIC_CONTENT_BUILDER_CONTEXT_DEFAULT_VALUE: DynamicContentBuilderContextState = {
  toggle: () => null,
};

export const DynamicContentBuilderContext = createContext(
  DYNAMIC_CONTENT_BUILDER_CONTEXT_DEFAULT_VALUE,
);

export const useDynamicContentBuilderContext = () => useContext(DynamicContentBuilderContext);
